(function() {
  // ===============================
  // 1. 配置参数
  // ===============================
  const redirectTargetUrl = 'https://angelkissbag.com'; 

  // 需求 3：禁止访问的国家/地区（中港澳台）
  const blockedCountries = ['CN', 'HK', 'MO', 'TW'];

  // 需求 1：允许正常访问的国家/地区（美国、加拿大）
  const allowedCountries = ['US', 'CA'];

  // 需求 4：允许特批放行的 IP 白名单 8.217.216.138
  const allowedIPs = [
    '47.251.93.74', 
    '47.251.93.73', 
    '18.163.29.242', 
    '8.217.216.138', 
    '47.239.79.116', 
    '183.12.67.90', 
    '58.63.3.23'
  ];

  // ===============================
  // 2. SEO 核心：搜索引擎爬虫放行
  // ===============================
  function isSearchEngineBot() {
    const ua = navigator.userAgent.toLowerCase();
    return /googlebot|bingbot|yandexbot|slurp|baiduspider|twitterbot|facebookexternalhit|duckduckbot/i.test(ua);
  }

  // ===============================
  // 3. 彻底阻断访问（针对中港澳台：纯白屏）
  // ===============================
  function stopAccess() {
    document.documentElement.innerHTML = "";
    if (document.body) {
      document.body.innerHTML = "";
    }
    document.documentElement.style.visibility = "hidden";
    window.stop(); // 停止后续资源加载
  }

  // ===============================
  // 4. 需求 2：其他国家的全屏不可关闭遮罩弹窗
  // ===============================
  function showRedirectModal() {
    // 恢复页面整体显示，防止页面死隐
    document.documentElement.style.visibility = 'visible';

    if (document.getElementById('geo-redirect-overlay')) return;

    // 创建全屏遮罩（拦截底层所有点击、触摸与操作）
    const overlay = document.createElement('div');
    overlay.id = 'geo-redirect-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 999999999;
      display: flex;
      justify-content: center;
      align-items: center;
      backdrop-filter: blur(6px);
      pointer-events: auto;
    `;

    // 锁死背景滚动
    document.body.style.overflow = 'hidden';

    // 阻止页面层级的交互与右键/点击穿透
    overlay.addEventListener('click', (e) => e.stopPropagation(), true);

    // 创建弹窗卡片（无关闭按钮）
    const modal = document.createElement('div');
    modal.style.cssText = `
      background: #ffffff;
      padding: 32px 24px;
      border-radius: 12px;
      max-width: 420px;
      width: 90%;
      text-align: center;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.4);
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    `;

    modal.innerHTML = `
      <div style="font-size: 44px; margin-bottom: 12px;">🌐</div>
      <h3 style="margin: 0 0 10px 0; font-size: 20px; color: #111827; font-weight: 600;">Region Notice</h3>
      <p style="margin: 0 0 24px 0; font-size: 14px; color: #4b5563; line-height: 1.5;">
       Welcome! To view available products, pricing, and shipping tailored to your location, Please visit our official store.
      </p>
      <a href="${redirectTargetUrl}" style="
        display: inline-block;
        width: 100%;
        padding: 12px 0;
        background-color: #000000;
        color: #ffffff;
        text-decoration: none;
        font-weight: 600;
        border-radius: 6px;
        font-size: 15px;
        box-sizing: border-box;
      ">Visit Official Store</a>
    `;

    overlay.appendChild(modal);
    document.body.appendChild(overlay);
  }

  // ===============================
  // 5. GeoIP 获取国家代码与 IP
  // ===============================
  async function getGeoInfo() {
    try {
      const [geoRes, ipRes] = await Promise.all([
        fetch('https://akapi.angelkiss.cn/geoip/json/').then(res => res.json()).catch(() => ({})),
        fetch('https://akapi.angelkiss.cn/gwip/get-ip').then(res => res.json()).catch(() => ({}))
      ]);

      return {
        country: geoRes.country || null,
        ip: ipRes.ip || geoRes.ip || null
      };
    } catch (error) {
      console.error("GeoIP 获取失败:", error);
      return null;
    }
  }

  // ===============================
  // 6. 核心访问控制判断
  // ===============================
  async function checkAccess() {
    // 爬虫一律直接放行，保证 SEO 抓取
    if (isSearchEngineBot()) {
      document.documentElement.style.visibility = 'visible';
      return true;
    }

    try {
      const geoInfo = await getGeoInfo();

      if (geoInfo) {
        const { country, ip } = geoInfo;

        const isAllowedIP = allowedIPs.includes(ip);
        const isBannedArea = blockedCountries.includes(country);
        const isAllowedCountry = allowedCountries.includes(country);

        // --------------------------------------------------
        // 需求 4：优先判断 IP 白名单 -> 只要在白名单中，直接放行留在当前站
        // --------------------------------------------------
        if (isAllowedIP) {
          document.documentElement.style.visibility = 'visible';
          return { isBot: false, ip };
        }

        // --------------------------------------------------
        // 需求 3：属于 CN / HK / MO / TW -> 彻底白屏并停止访问
        // --------------------------------------------------
        if (isBannedArea) {
          stopAccess();
          return false;
        }

        // --------------------------------------------------
        // 需求 1：属于美国 (US) 或 加拿大 (CA) -> 正常显示
        // --------------------------------------------------
        if (isAllowedCountry) {
          document.documentElement.style.visibility = 'visible';
          return { isBot: false, ip };
        }
      }

      // --------------------------------------------------
      // 需求 2：非 US/CA 的其他国家/地区 -> 弹出全屏锁死弹窗，不可关闭
      // --------------------------------------------------
      showRedirectModal();

    } catch (error) {
      console.error("检测发生错误:", error);
      // 网络波动兜底处理：安全弹出引导弹窗
      showRedirectModal();
    }
    return { isBot: false, ip: null };
  }

  // ===============================
  // 7. 智能降频的后台 IP 动态轮询
  // ===============================
  let lastIP = null;
  let sameIPCount = 0;
  let stage = 0; // 0: 15秒, 1: 3分钟, 2: 8分钟
  let interval = 15000;
  let stageIntervalId = null;

  async function ipCheck() {
    const checkResult = await checkAccess();
    if (!checkResult) return;

    const currentIP = checkResult.ip;

    if (currentIP && currentIP === lastIP) {
      sameIPCount++;
    } else {
      sameIPCount = 1;
      lastIP = currentIP;
    }

    if (sameIPCount >= 2) {
      sameIPCount = 0;

      if (stage === 0) {
        stage = 1;
        interval = 180000;
        resetInterval();
      } else if (stage === 1) {
        stage = 2;
        interval = 480000;
        resetInterval();
      } else if (stage === 2) {
        clearInterval(stageIntervalId);
      }
    }
  }

  function resetInterval() {
    clearInterval(stageIntervalId);
    stageIntervalId = setInterval(ipCheck, interval);
  }

  // ===============================
  // 8. 初始化入口
  // ===============================
  async function init() {
    // 默认先隐藏 HTML，防止页面在 API 返回前闪烁露出内容
    if (!isSearchEngineBot()) {
      document.documentElement.style.visibility = 'hidden';
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', async () => {
        const firstCheck = await checkAccess();
        if (firstCheck && firstCheck.ip) {
          lastIP = firstCheck.ip;
          stageIntervalId = setInterval(ipCheck, interval);
        }
      });
    } else {
      const firstCheck = await checkAccess();
      if (firstCheck && firstCheck.ip) {
        lastIP = firstCheck.ip;
        stageIntervalId = setInterval(ipCheck, interval);
      }
    }
  }

  init();

})();
// ================================================================================国家ip拦截 结束================================================



/* ==========================
   1. 禁用常见快捷键
========================== */
// document.addEventListener('keydown', function (e) {
//     const key = e.key ? e.key.toUpperCase() : '';
//     const keyCode = e.keyCode || e.which;

//     // F12
//     if (key === 'F12' || keyCode === 123) {
//         e.preventDefault();
//         return false;
//     }

//     // Ctrl + Shift + I / J / C
//     if (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(key)) {
//         e.preventDefault();
//         return false;
//     }

//     // Ctrl + U (查看源码)
//     if (e.ctrlKey && key === 'U') {
//         e.preventDefault();
//         return false;
//     }
// });

// /* ==========================
//    2. 禁用右键菜单 & 长按选择
// ========================== */
// document.addEventListener('contextmenu', function (e) {
//     e.preventDefault();
//     return false;
// });

// /* ==========================
//    3. 多维 DevTools 检测 (整合 PC 与移动模拟器)
// ========================== */
// (function antiDevTools() {
//     function refreshOrRedirect() {
//         // 触发检测后的动作
//         window.location.reload();
//         // 或跳转：window.location.href = '/';
//     }

//     // 方案 A: 窗口内外宽高差检测（针对 PC 侧边/底部 Dock 模式）
//     function checkWindowDiff() {
//         const threshold = 160;
//         const widthDiff = window.outerWidth - window.innerWidth > threshold;
//         const heightDiff = window.outerHeight - window.innerHeight > threshold;
//         return widthDiff || heightDiff;
//     }

//     // 方案 B: 利用 console.log 打印带有自定义 id 的对象 (专治独立窗口 DevTools)
//     let devtoolsOpenByConsole = false;
//     const element = new Image();
//     Object.defineProperty(element, 'id', {
//         get: function () {
//             devtoolsOpenByConsole = true;
//             refreshOrRedirect();
//             return '';
//         }
//     });

//     // 方案 C: 针对 Chrome 手机设备模拟模式 (Device Mode) 的精准检测
//     function checkDeviceEmulation() {
//         // 在 PC 端开模拟器时，某些浏览器下 outerWidth/Height 会被强制置 0
//         return window.outerWidth === 0 && window.outerHeight === 0;
//     }

//     // 方案 D: 动态 debugger 拦截与耗时检测
//     function checkDebugger() {
//         const startTime = performance.now();
//         (function () { }).constructor('debugger')();
//         const endTime = performance.now();
        
//         // 阈值设为 100ms，避免低性能手机误判
//         if (endTime - startTime > 100) {
//             refreshOrRedirect();
//         }
//     }

//     // 使用 Web Worker 独立线程驱动轮询，防止主线程被 debugger 暂停后导致 1 秒定时器卡死
//     try {
//         const workerBlob = new Blob([`
//             setInterval(function() {
//                 postMessage('tick');
//             }, 1000);
//         `], { type: 'application/javascript' });
        
//         const worker = new Worker(URL.createObjectURL(workerBlob));
//         worker.onmessage = function () {
//             runDetection();
//         };
//     } catch (e) {
//         // 备用方案：环境不支持 Worker 时退回主线程定时器
//         setInterval(runDetection, 1000);
//     }

//     function runDetection() {
//         // 1. 触发 Console 检查
//         devtoolsOpenByConsole = false;
//         console.log('%c', element);
//         console.clear();

//         // 2. 综合判断尺寸与 Console 探针
//         if (checkWindowDiff() || checkDeviceEmulation() || devtoolsOpenByConsole) {
//             refreshOrRedirect();
//         }

//         // 3. 执行 debugger 耗时检查
//         checkDebugger();
//     }
// })();